<app-rbac-group [data]="data" (submitGroup)="submit($event)"></app-rbac-group>
